(function () {
	const searchModal = () => {
		// jQuery .click(fn) bound a handler to every match; searchModal also runs
		// again on each shopify:section:load, so binding a fresh handler per call
		// keeps the previous behaviour.
		document
			.querySelectorAll(
				".search-modal-trigger,.search-modal__overlay,.search__close"
			)
			.forEach((el) => {
				el.addEventListener("click", function (e) {
					e.preventDefault();
					searchToggle();
				});
			});
	};
	document.addEventListener("keyup", function (e) {
		// jQuery hasClass on a set is true when ANY element carries the class
		const isActive = Array.prototype.some.call(
			document.querySelectorAll(".search-modal"),
			(el) => el.classList.contains("active")
		);
		if (isActive && e.key == "Escape") {
			searchToggle();
		}
	});
	function searchToggle() {
		const searchModalEl = document.querySelector("#search-modal");
		// .header-overlay may match several nodes; jQuery toggled each one
		const overlays = document.querySelectorAll(".header-overlay");

		if (searchModalEl) searchModalEl.classList.toggle("active");
		overlays.forEach((el) => el.classList.toggle("color-background-1"));

		if (searchModalEl && searchModalEl.classList.contains("active")) {
			searchModalEl
				.querySelectorAll(".search__input")
				.forEach((el) => el.focus());
			overlays.forEach((el) => el.classList.add("color-background-1"));
		} else {
			document
				.querySelectorAll(".search-modal-trigger")
				.forEach((el) => el.focus());
		}

		document.body.classList.toggle("overflow-hidden");
	}
	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
